import React, { useCallback } from "react";
import { Patient } from "@shared/models";
import { SidebarBackButton } from "@shared/components/Sidebar/components/SidebarBackButton";
import { Button, FieldPreview } from "@shared/components";
import { getFullName } from "@shared/utils";
import { TIMEZONE } from "@shared/constants";

import { StationsPreview, SensorsPreview } from "./components";

import "./index.scss";

interface PatientSidebarContainerProps {
  patient: Patient | null;
  onEditPatientClick?: (patient: Patient | null) => void;
  onBackBtnClick?: () => void;
}

const PatientDetailsSidebar = (props: PatientSidebarContainerProps) => {
  const { patient, onEditPatientClick, onBackBtnClick } = props;

  const { stations } = patient || {};

  const handleEditBtnClick = useCallback(() => {
    onEditPatientClick && onEditPatientClick(patient);
  }, [patient, onEditPatientClick]);

  const handleBackBtnClick = useCallback(() => {
    onBackBtnClick && onBackBtnClick();
  }, [onBackBtnClick]);

  return (
    <div className="patient-sidebar-container">
      <SidebarBackButton onClick={handleBackBtnClick} />

      <div className="patient-sidebar-content">
        {(patient?.first_name || patient?.last_name) && (
          <div className="patient-sidebar-patient-id">{getFullName(patient)}</div>
        )}
        <FieldPreview
          className="patient-sidebar-field"
          label="Time Zone"
          value={patient?.patient_settings?.timezone || TIMEZONE.UTC}
        />
        <FieldPreview className="patient-sidebar-field" label="Gender" value={patient?.gender || "-"} />
        <FieldPreview className="patient-sidebar-field" label="Age" value={patient?.age || "-"} />
        <FieldPreview className="patient-sidebar-field" label="Phone Number" value={patient?.phone || "-"} />
        <FieldPreview className="patient-sidebar-field" label="Email Address" value={patient?.email || "-"} />
        <FieldPreview
          className="patient-sidebar-field"
          label="Assigned Staff"
          value={(patient?.assigned_users || []).map(getFullName).join(",\r\n")}
        />
        <hr />
        <FieldPreview
          className="patient-sidebar-field"
          label="SDH"
          value={<StationsPreview stations={stations || []} />}
        />
        <FieldPreview
          className="patient-sidebar-field"
          label="Vital Signs"
          value={<SensorsPreview stations={stations} />}
        />
        <div className="edit-patient-btn">
          <Button
            disabled={!patient || !onEditPatientClick}
            className="edit-patient-btn outline-blue full-width"
            onClick={handleEditBtnClick}
          >
            Edit Patient
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PatientDetailsSidebar;
